import { Image } from "./image";
import React from "react";

export const Servicios = ({data}) => {
  return (
    <div id="servicios" className="text-center">
      <div className="container-servicios">
        <div className="section-title">
          <h2>Expolorar Servicios</h2>
          <div className="section-subtitle-servicios">
            <p style={{color:'#0j0'}}>Compromiso con la excelencia</p><br></br>
          </div>
          <p>
            Entendemos lo importante que es tu vehículo para ti. Por eso, trabajamos con dedicación para ofrecerte un servicio confiable y transparente. Tu seguridad y satisfacción son nuestra prioridad.
          </p>
          <p>
            ¡Visítanos y descubre por qué somos la mejor opción para tu Ford o Mazda!
          </p>
        </div>
        <div className="section-subtitle">
          <h2>Mecànica Bàsica</h2>
        </div>
        <div className="row text-description">
            {data[0]
              ? data[0].map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      description={d.description}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />

                    <div class="text-with-line">
                      <p>{d.title}</p>
                    </div>

                  </div>
                ))
              : "Loading..."}
        </div>

        <div className="section-subtitle" style={{margin: '150px 0 0 40px'}}>
          <h2>Mecànica Especializada</h2>
        </div>
        <div className="row text-description">
            {data[1]
              ? data[1].map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      description={d.description}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />

                    <div class="text-with-line">
                      <p>{d.title}</p>
                    </div>

                  </div>
                ))
              : "Loading..."}
        </div>

      </div>
    </div>
  );
};